import { ModuleDataType } from 'types/interfacePreviewTypes';

export const wippe_cii_rot_l_s: ModuleDataType = {
  outputPdf: null,
  userUploadedFilesDescriptions: [],
  userUploadedFiles: [],
  id: null,
  projectTitle: '',
  configuratorPreviewScreenshot: null,
  isSubmitted: false,
  createdAt: null,
  updatedAt: null,
  userInfo: {
    name: '',
    lastname: '',
    firma: '',
    email: '',
    telephoneNumber: '',
    clientNumber: null,
    comments: '',
    country: '',
    postalCode: '',
  },

  background: {
    active: true,
    type: 'image',
    // imageUrl:
    //   'https://firebasestorage.googleapis.com/v0/b/miunskekonfigurator.appspot.com/o/images%2Fwippen-images%2Fmar-2025%2FCarling_Wippen_0003_5001383.png?alt=media&token=deb54472-b581-4b2d-85b7-56fcef4225eb',
    imageUrl:
      'https://firebasestorage.googleapis.com/v0/b/miunskekonfigurator.appspot.com/o/images%2Fwippen-images%2Fmar-2-2025%2Fcii_rot_l_s.png?alt=media&token=691f6e40-f7e4-47b2-90a7-2f120a2bdd13',
    thumbnail: null,
  },

  rotation: '0',
  module: 'Contura II - Wippe rot mit Linse + Strichlinse',
  version: '1.0',

  elements: {
    symbols: {
      0: {
        active: false,
        color: '#0e1111',
        icon: null,

        variant: 'bottom',
      },
      1: {
        active: true,
        color: '#0e1111',
        icon: null,
        variant: 'top',
      },
    },
  },
};
